/**
 * Add event listeners to all anchor tags inside .obw-header__nav
 */
document.querySelectorAll(".obw-header-mega-dropdown li a").forEach(function (item) {
  item.addEventListener("mouseover", function () {
    const imageUrl = this.getAttribute("data-image-url");
    // Find the closest .obw-header-mega-dropdown and then get the .obw-hover-image within it
    const dropdownContainer = this.closest(".obw-header-mega-dropdown");
    const hoverImage = dropdownContainer.querySelector(".obw-hover-image");

    if (imageUrl && hoverImage) {
      hoverImage.src = imageUrl;
      hoverImage.classList.add("visible");
    }
  });

  item.addEventListener("mouseout", function () {
    // Find the closest .obw-header-mega-dropdown and then get the .obw-hover-image within it
    const dropdownContainer = this.closest(".obw-header-mega-dropdown");
    const hoverImage = dropdownContainer.querySelector(".obw-hover-image");

    if (hoverImage) {
      hoverImage.classList.remove("visible");
    }
  });
});

// Function to add 'is-menu-opened' class to the nearest '.header'
function addActiveClass(event) {
    const parentHeader = event.currentTarget.closest('.header');
    const siblingMegaDropdown = event.currentTarget.parentElement.querySelector('.obw-header-mega-dropdown');

    if (parentHeader && siblingMegaDropdown) {
        parentHeader.classList.add("is-menu-opened");
    }else{
        parentHeader.classList.remove("is-menu-opened");
    }
}

// Function to remove 'is-menu-opened' class from all '.header' elements
function removeActiveClass() {
    const headers = document.querySelectorAll('.header.is-menu-opened');
    headers.forEach(header => header.classList.remove("is-menu-opened"));
}

// Attach mouseover event listeners to each disclosure element
document.querySelectorAll(".header__primary-nav li .header__menu-disclosure summary").forEach(element => {
    element.addEventListener("mouseover", function(event) {
        addActiveClass(event);
    });
});

// Attach click event listener to the document
document.querySelector('.obw-header-mega-dropdown, .header').addEventListener("mouseleave", function() {
    removeActiveClass();
});

// Dimension CM calculation to INC
document.addEventListener('DOMContentLoaded', function () {
  const conversionFactor = 0.393701; // cm to inch
  const volumeConversionFactor = 61.0237; // L to cubic inches
  const animationDuration = 500; // Animation duration in milliseconds

  // Function to convert cm to inches
  const convertCmToInch = cm => Math.round(cm * conversionFactor);

  // Function to convert L to cubic inches
  const convertLToCuIn = L => Math.round(L * volumeConversionFactor);

  // Function to animate number change
  const animateNumberChange = (element, from, to, duration) => {
    if (!element) return; // Prevent errors if element is missing
    const startTime = performance.now();

    const step = currentTime => {
      const elapsedTime = currentTime - startTime;
      const progress = Math.min(elapsedTime / duration, 1);
      const currentNumber = Math.round(from + (to - from) * progress);

      element.textContent = currentNumber;

      if (progress < 1) {
        requestAnimationFrame(step);
      }
    };

    requestAnimationFrame(step);
  };

  // Function to update dimensions and volume
  const updateValues = (section, unit, initialDimensions, initialVolume) => {
    const lengthElem = section.querySelector('.dimension-length');
    const widthElem = section.querySelector('.dimension-width');
    const heightElem = section.querySelector('.dimension-height');
    const unitElems = section.querySelectorAll('.dimension-unit');

    const volumeElem = section.querySelector('.dimension-volume');
    const volumeUnitElem = section.querySelector('.dimension-unit-volume');

    let newLength, newWidth, newHeight, newVolume;

    if (unit === 'in') {
      newLength = convertCmToInch(initialDimensions.length);
      newWidth = convertCmToInch(initialDimensions.width);
      newHeight = convertCmToInch(initialDimensions.height);
      newVolume = convertLToCuIn(initialVolume);
    } else {
      newLength = Math.round(initialDimensions.length);
      newWidth = Math.round(initialDimensions.width);
      newHeight = Math.round(initialDimensions.height);
      newVolume = Math.round(initialVolume);
    }

    // Animate changes
    animateNumberChange(lengthElem, parseFloat(lengthElem.textContent), newLength, animationDuration);
    animateNumberChange(widthElem, parseFloat(widthElem.textContent), newWidth, animationDuration);
    animateNumberChange(heightElem, parseFloat(heightElem.textContent), newHeight, animationDuration);

    unitElems.forEach(elem => elem.textContent = unit);

    if(volumeElem){
      animateNumberChange(volumeElem, parseFloat(volumeElem.textContent), newVolume, animationDuration);
      volumeUnitElem.textContent = unit === 'in' ? 'cu in' : 'L';
    }
  };

  // Function to update active button
  const updateActiveButton = (section, unit) => {
    section.querySelectorAll('.switch-unit').forEach(button => {
      button.classList.toggle('active', button.dataset.unit === unit);
    });
  };

  // Loop through each section
  document.querySelectorAll('.obw-dimension-section').forEach(section => {
    const volumeElement = section.querySelector('.dimension-volume');

    // Store initial values
    const initialDimensions = {
      length: parseFloat(section.querySelector('.dimension-length').textContent.trim()) || 0,
      width: parseFloat(section.querySelector('.dimension-width').textContent.trim()) || 0,
      height: parseFloat(section.querySelector('.dimension-height').textContent.trim()) || 0
    };

    let initialVolumeText = '';
    if (volumeElement) {
      initialVolumeText = volumeElement.textContent.trim();
    }
    const initialVolume = initialVolumeText ? parseFloat(initialVolumeText.replace(/,/g, '')) : 0;

    let currentUnit = 'cm';

    // Initialize with cm as default
    updateValues(section, 'cm', initialDimensions, initialVolume);
    updateActiveButton(section, 'cm');

    // Add event listener to buttons
    section.querySelectorAll('.switch-unit').forEach(button => {
      button.addEventListener('click', () => {
        const selectedUnit = button.dataset.unit;
        if (selectedUnit !== currentUnit) {
          updateValues(section, selectedUnit, initialDimensions, initialVolume);
          updateActiveButton(section, selectedUnit);
          currentUnit = selectedUnit;
        }
      });
    });
  });
});
